/* saluvivo: Kontakt ohne Umweg über die Kontaktseite.
   Das echte Formular liegt beim Laden unsichtbar am Seitenende (#sv-contact-src) und wird bei jedem Klick auf «Kontakt»
   in ein Fenster verschoben: Desktop von rechts, Handy von unten. Kommt der Klick aus dem Menü, schliesst sich das Menü zuerst.
   Gesendet wird ganz normal über Shopify (inkl. Spam-Schutz); danach kommt man auf dieselbe Seite zurück und sieht eine Bestätigung.
   Auf der Kontaktseite selbst bleibt alles wie gehabt. */
(function(){
  if(window.svKontakt)return;window.svKontakt=true;
  var PATH=/\/pages\/(kontakt|contact)\/?$/i;
  var onPage=PATH.test(location.pathname);
  var rm=window.matchMedia('(prefers-reduced-motion: reduce)');
  function S(){return document.getElementById('sv-contact-src');}
  function N(){return document.querySelector('.svk');}

  /* Formular vorbereiten (Thema, Herkunft, Nachricht aus dem Finder, WhatsApp-Text) */
  function prep(ctx){
    var s=S(),n=N();if(!s||!n)return null;
    var form=n.querySelector('form');
    if(ctx.topic){var r=form.querySelector('input[data-k="'+ctx.topic+'"]');if(r)r.checked=true;}
    var src=form.querySelector('[data-svk-src]');if(src)src.value=document.title+' – '+location.href.split('?')[0];
    var ta=form.querySelector('textarea');
    if(ta&&(!ta.value.trim()||ta.dataset.auto===ta.value)){ta.value=ctx.msg?ctx.msg+'\n\n':'';ta.dataset.auto=ta.value;}
    var wa=n.querySelector('.svk__wa');
    function upd(){
      var c=form.querySelector('input[name="contact[Thema]"]:checked');
      var txt=s.getAttribute('data-wa-text')+' '+(c?c.value:'')+'.';if(ctx.msg)txt+=' '+ctx.msg;
      wa.href='https://wa.me/'+s.getAttribute('data-wa')+'?text='+encodeURIComponent(txt);
    }
    upd();form.onchange=upd;
    if(!form.dataset.svk){
      form.dataset.svk='1';
      form.addEventListener('submit',function(){
        try{sessionStorage.setItem('svk_sent','1');}catch(e){}
        var b=form.querySelector('.svk__send');if(b)b.textContent=s.getAttribute('data-sending');
      });
    }
    return n;
  }

  function ctxOf(a){
    var c={},fb=a.closest('[class*="svbf-"]');
    if(fb){
      c.topic='bt';
      var names=[].map.call(fb.querySelectorAll('.svpf__card:not([hidden]) strong'),function(x){return x.textContent.trim();});
      if(names.length)c.msg=S().getAttribute('data-interest')+' '+names.join(', ');
    }
    return c;
  }

  /* Fenster */
  var layer=null,last=null;
  function closeP(){
    if(!layer||!layer.classList.contains('is-open'))return;
    layer.classList.remove('is-open');
    var pnl=layer.querySelector('.svk-panel');pnl.style.transform='';
    setTimeout(function(){layer.classList.remove('is-on');document.documentElement.classList.remove('svk-lock');},rm.matches?0:420);
    if(last&&last.focus&&document.contains(last))last.focus({preventScroll:true});
  }
  function panel(ctx){
    if(!layer){
      layer=document.createElement('div');layer.className='svk-layer';
      layer.innerHTML='<div class="svk-scrim"></div><div class="svk-panel" role="dialog" aria-modal="true"><span class="svk-grip" aria-hidden="true"></span><button type="button" class="svk-x" aria-label="'+S().getAttribute('data-close')+'"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button><div class="svk-panel__body"></div></div>';
      document.body.appendChild(layer);
      layer.querySelector('.svk-scrim').addEventListener('click',closeP);
      layer.querySelector('.svk-x').addEventListener('click',closeP);
      document.addEventListener('keydown',function(e){if(e.key==='Escape')closeP();});
      /* Handy: Blatt am Griff nach unten ziehen zum Schliessen */
      var pnl=layer.querySelector('.svk-panel'),grip=layer.querySelector('.svk-grip'),start=null,dy=0;
      grip.addEventListener('touchstart',function(e){start=e.touches[0].clientY;dy=0;pnl.style.transition='none';},{passive:true});
      grip.addEventListener('touchmove',function(e){if(start===null)return;dy=Math.max(0,e.touches[0].clientY-start);pnl.style.transform='translateY('+dy+'px)';},{passive:true});
      grip.addEventListener('touchend',function(){if(start===null)return;pnl.style.transition='';start=null;if(dy>90)closeP();else pnl.style.transform='';});
    }
    var n=prep(ctx);if(!n)return;
    layer.querySelector('.svk-panel__body').appendChild(n);
    layer.querySelector('.svk-panel').scrollTop=0;
    layer.classList.add('is-on');document.documentElement.classList.add('svk-lock');
    requestAnimationFrame(function(){requestAnimationFrame(function(){layer.classList.add('is-open');});});
    /* Auf dem Handy kein automatischer Fokus, damit die Tastatur nicht sofort aufspringt */
    setTimeout(function(){if(window.innerWidth>=750){var i=layer.querySelector('input[name="contact[name]"]');if(i)i.focus({preventScroll:true});}else layer.querySelector('.svk-x').focus({preventScroll:true});},380);
  }

  /* Menü schliessen, falls der Klick aus dem Menü kommt; true = es war offen */
  function closeMenu(a){
    var hd=a.closest('header-drawer,.menu-drawer-container');if(!hd)return false;
    var det=hd.matches('details')?hd:hd.querySelector('details.menu-drawer-container');
    if(det&&!det.open)return false;
    var host=hd.matches('header-drawer')?hd:hd.closest('header-drawer');
    try{if(host&&typeof host.close==='function'){host.close();return true;}}catch(e){}
    var btn=(host||hd).querySelector('.menu-drawer__close-button');
    if(btn){btn.click();return true;}
    if(det){det.classList.remove('menu-open');det.removeAttribute('open');document.body.style.overflow='';return true;}
    return false;
  }

  document.addEventListener('click',function(e){
    if(onPage||e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
    var a=e.target.closest&&e.target.closest('a[href]');if(!a||!S())return;
    var u;try{u=new URL(a.getAttribute('href'),location.href);}catch(x){return;}
    if(u.origin!==location.origin||!PATH.test(u.pathname))return;
    e.preventDefault();e.stopPropagation();
    var ctx=ctxOf(a);
    last=a.closest('header-drawer,.menu-drawer')?document.querySelector('.header__icon--menu'):a;
    if(closeMenu(a))setTimeout(function(){panel(ctx);},rm.matches?0:280);
    else panel(ctx);
  },true);

  /* Zurück nach dem Senden: kurze Bestätigung */
  function toast(){
    var sent=false;try{sent=sessionStorage.getItem('svk_sent')==='1';sessionStorage.removeItem('svk_sent');}catch(e){}
    if(onPage||!S()||!(sent||/contact_posted=true/.test(location.search)))return;
    var d=document.createElement('div');d.className='svk-toast';d.setAttribute('role','status');d.textContent=S().getAttribute('data-ok');
    document.body.appendChild(d);requestAnimationFrame(function(){requestAnimationFrame(function(){d.classList.add('is-on');});});
    setTimeout(function(){d.classList.remove('is-on');setTimeout(function(){d.remove();},500);},6000);
    try{var x=new URL(location.href);x.searchParams.delete('contact_posted');x.hash='';history.replaceState(null,'',x.toString());}catch(err){}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',toast);else toast();
})();
